import { getCalcInputState } from "../../../../../utils/selectors";
import { trussSlice } from "./slice";

export const getTrussState = state => getCalcInputState(state)[trussSlice.name];